import "../css/TeeStyles.css";
import { ListIconText } from "./smallComponents/listIconText";
import Dots from "../icons/assets/Dots.png";
import React from "react";

const SectionTwo: React.FC = () => {
  return (
    <div className="pt-5 pb-3 section px-md-5 p-3 px-4 mcm-dark-bg d-flex flex-wrap position-relative">
      <div className="wid45 wid100Mobile" data-aos="fade-up-right">
        <span className="white d-block wid80 wid100Mobile fontSize34px text-md-start text-center lh-sm boldSeven">
          Unleash Your Creativity with Our Studio Services
        </span>
        <span className="fontSize14px boldFour lh-base white mt-4 text-md-start text-center d-block wid90 wid100Mobile">
          At MCM, we understand that every project is unique, requiring
          specialized environments and professional-grade equipment to bring
          your vision to life. Whether you're recording a podcast, producing a
          video, capturing stunning photographs, or hosting a seminar, our
          studio offers the ideal space, tools, and expertise to elevate your
          work. Explore our tailored services below and find the perfect match
          for your creative needs.
        </span>
        <button
          onClick={() => {
            window.location.href = "services";
          }}
          className="bgWhite d-block wid30Mobile mx-md-0 mx-auto wid30 boldSeven mt-4 rounded-3 border-none mcm-dark fontSize16px p-2"
        >
          EXPLORE MORE
        </button>
      </div>
      <div className="wid54 wid100Mobile d-flex flex-wrap justify-content-between mt-md-0 mt-5">
        <ListIconText
          images="icon-1.png"
          text="PHOTOGRAPHY"
          marginBottom="3rem"
        />
        <ListIconText images="icon-2.png" text="SEMINARS" marginBottom="3rem" />
        <ListIconText images="icon-3.png" text="PODCASTS" marginBottom="3rem" />
        <ListIconText
          images="icon-4.png"
          text="VIDEO PRODUCTION"
          marginBottom="0rem"
        />
      </div>
      <img
        className="position-absolute"
        src={Dots}
        style={{ top: "43%", right: "0", zIndex: 0 }}
        alt="margineofel"
      />
    </div>
  );
};

export default SectionTwo;
